import React, { use, useState } from "react";
import styles from "./EnquiresDashboard.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import { FiEdit2 } from "react-icons/fi";
import EnquiriesGraph from "../../sections/EnquiresGraph/EnquiriesGraph";
import CommunicationOverview from "../../sections/CommunicationOverview/CommunicationOverview";
import DueFollowUps from "../../sections/DueFollowUps/DueFollowUps";
import UpcomingAdmissions from "../../sections/UpcomingAdmissions/UpcomingAdmissions";
import CopyRight from "../../components/CopyRight/CopyRight";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";

export const EnquiresDashboard = () => {
  const [count, setCount] = useState(5);
  const dispatch=useDispatch();

  const handleEditClick = () => {
     dispatch(openModal("chooseRange"));
  };

  const handleCheckNow = () => {
    console.log("Check Now clicked");
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* Top Row */}
        <div className={styles.rowWrapper}>
          <div className={styles.cardsWrapper}>
            <ResultAndCount
              label="Total Enquiries"
              count={count}
              bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Total Conversions"
              count={0}
              bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Follow up Overdue"
              count={0}
              bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
              textColor="Black_Color"
            />
            <ResultAndCount
              label="Tasks Overdue"
              count={0}
              bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
              textColor="Black_Color"
            />
          </div>

          <div className={styles.editWrapper} onClick={handleEditClick}>
            <FiEdit2 size={16} />
            <span>This Month</span>
          </div>
        </div>

        {/* Bottom Info Row */}
        <div className={styles.infoRow}>
          <div className={styles.circle}>{count}</div>
          <p className={styles.text}>
            You have created INR {count} enquiries with in last 7 days
          </p>
          <button className={styles.button} onClick={handleCheckNow}>
            Check Now
          </button>
        </div>

        <div className={styles.gridSection}>
          <div className={styles.gridItem}>
            <EnquiriesGraph />
          </div>
          <div className={styles.gridItem}>
            <CommunicationOverview />
          </div>
          <div className={styles.gridItem}>
            <DueFollowUps />
          </div>
          <div className={styles.gridItem}>
            <UpcomingAdmissions />
          </div>
        </div>
      </div>
      <CopyRight/>
    </div>
  );
};
export default EnquiresDashboard;